export default __webpack_public_path__ + "static/media/Note.eea8c292.svg";